const Pagination = ({
  handlePrev,
  currentPage,
  totalPages,
  setCurrentPage,
  handleNext,
  handlePageClick
}) => {
  return (
    <div className="pagination-container">
      <button onClick={handlePrev} disabled={currentPage === 1} className="pagination-btn">
      &larr; Prev
      </button>
      {Array.from({ length: totalPages }, (_, index) => index + 1)
        .slice(
          Math.max(0, currentPage - 2),
          Math.min(totalPages, currentPage + 1)
        )
        .map((page) => (
          <button
            key={page}
            className={`pagination-btn number ${currentPage === page ? "active" : ""}`}
            onClick={() => setCurrentPage(page)}
          >
            {page}
          </button>
        ))}
      <button onClick={handleNext} disabled={currentPage === totalPages} className="pagination-btn">
         Next &rarr;
      </button>
    </div>
  );
};

export default Pagination;
